import { dataOutdent } from 'dls-icons-data'
import { createIcon } from '../common'

const IconOutdent = /*#__PURE__*/createIcon(dataOutdent)
export default IconOutdent
